<app-menu headerCSS="header-transparent" displayLogo="false"></app-menu>
<section class="banner bg-holder bg-overlay-black-30 text-white"
  style="background-image: url(assets/images/bg/banner-2.svg)">
  <div class="container-fluid container0-position">
    <div class="row">
      <div class="col-12 text-center">
        <h1 class="manzoul-label">Manzoul</h1>
        <h2>The UK’s Language Marketplace</h2>
      </div>
    </div>
  </div>

  <div class="container-fluid container1-position">
    <div class="row">
      <div class="col-12 text-center">
        <h2 class="text-white mb-3">Championing <span class="text-primary"> Quality Services </span>and <span
            class="text-primary">Ethical Partnerships</span>
        </h2>
        <p class="lead mb-4 mb-lg-5 font-weight-normal">Find Jobs &amp; Community</p>
        <job-filter [isHomePage]="true"></job-filter>
        <div class="job-tag mt-4">
          <ul class="justify-content-center">
            <li class="text-primary">Trending Keywords :</li>
            <ng-container *ngFor="let trendingKeyword of lookupStore.trendingKeywords | async;last as isLast ">
              <li><a class="anchor-link"
                  (click)="onTrendingKeywordClicked(trendingKeyword.name)">{{trendingKeyword.name}}</a></li>
              <ng-container *ngIf="!isLast">,</ng-container>
            </ng-container>
          </ul>
        </div>
        <app-advance-job-filter></app-advance-job-filter>
      </div>
    </div>
  </div>
  <div class="bg-primary py-4 py-lg-5 container-fluid container2-position">
    <div class="row align-items-center">
      <div class="col-lg-7 mb-4 mb-sm-4 mb-lg-0">
      </div>
      <div class="col-md-5 text-lg-right">
        <div class="d-sm-flex">
          <h4 class="text-white mt-3 mr-3">Break <span class="text-primary">Language </span>Barriers</h4>
          <button class="btn btn-dark" (click)="onPostJobClicked()" routerLink="">Post Job</button>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="latest-jobs-container">
  <app-latest-jobs></app-latest-jobs>
</section>

<section class="vid-container">
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-12">
        <h3>What is Manzoul</h3>
        <p>
          Manzoul is a social enterprise platform founded on the principles of ethical cooperation and fairness. Using
          advanced technology, it connects clients who value high-quality work and respectful partnerships with talented
          linguists, including translators, interpreters, language teachers, and voice-over artists.
        </p>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-6 col-md-6 col-lg-6">
        <h3>How Manzoul Works:</h3>
        <ul class="mt-4">
          <li class="mb-4">
            <h5>Free to Join and Post Jobs</h5>
            <p>Clients can post jobs, browse linguists, and check reviews for free. Payment is only required when hiring
              a linguist, ensuring a secure and fair transaction.</p>
          </li>
          <li class="mb-4">
            <h5>Secure Payment System</h5>
            <p>Manzoul ensures secure payments, releasing funds to linguists only upon project completion and client
              approval. A trusted platform for hassle-free transactions.</p>
          </li>
          <li class="mb-4">
            <h5>Privacy and Support</h5>
            <p>Manzoul prioritizes user privacy, keeping data safe. A dedicated support team is available to assist,
              making the user experience seamless.</p>
          </li>
        </ul>
      </div>
      <div class="col-6 col-md-6 col-lg-6">
        <iframe class="w-100" height="315" [src]="safeVideoUrl" frameborder="0" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</section>

<section>
  <div class="container desc-container">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-12">
        <h3>Our Vision</h3>
        <p>
          Manzoul is a social enterprise platform founded on the principles of ethical cooperation and fairness. Using
          advanced technology, it connects clients who value high-quality work and respectful partnerships with talented
          linguists, including translators, interpreters, language teachers, and voice-over artists.
        </p>
      </div>
    </div>
    <div class="row">
      <!-- For Clients Column -->
      <div class="col-12 col-md-6 mb-4">
        <h4>We envision a future where:
        </h4>
        <ul>
          <li>
            <p>Clients and linguists collaborate with mutual respect and transparency.
            </p>
          </li>
          <li>
            <p>Linguists set their own fair rates, with timely payments for agreed milestones and clear platform fees.
            </p>
          </li>
          <li>
            <p>Fair working conditions and sustainable careers are the norm — not the exception.</p>
          </li>
          <li>
            <p>Linguists have a meaningful stake in the platform, with models of workers’ ownership.</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 mb-4">
        <h4>To support this vision, our platform offers:
        </h4>
        <ul class="mt-4">
          <li>
            <h5>Seamless Communication</h5>
            <p>Incorporating direct messaging for efficient and smooth interactions.
            </p>
          </li>
          <li>
            <h5>Private Feedback & Public Reviews</h5>
            <p>Enabling constructive private feedback while building trust through
              transparent public reviews.
            </p>
          </li>
          <li>
            <h5>Escrow Payment System</h5>
            <p>Securely holding payments until work is delivered and approved, ensuring fairness
              for both parties.</p>
          </li>
          <li>
            <h5>Data Privacy</h5>
            <p>Ensuring your privacy is protected with robust data safeguards while maintaining smooth and secure
              communication.</p>
          </li>
        </ul>
      </div>
      <p>
        We believe in building a future where language professionals are valued, empowered, and have real influence over
        the systems to enable them to give their best services — creating a better, more ethical language services
        marketplace for everyone.
      </p>
    </div>
  </div>
</section>

<section>
  <div class="vid-container">
    <div class="container">
      <div class="row">
        <!-- For Clients Column -->
        <div class="col-12 col-md-6 mb-4">
          <h4>For Clients</h4>
          <ul class="mt-4">
            <li>
              <h5>Streamlined Hiring Process</h5>
              <p>Manzoul simplifies the hiring process, making it efficient and user-friendly. It is free to post jobs,
                receive offers, and select the right talent seamlessly.</p>
            </li>
            <li>
              <h5>Choose the Right Talent</h5>
              <p>Empower your decision-making by comparing linguists based on skills, qualifications, years of
                experience,
                and client reviews. Manzoul provides a comprehensive overview to ensure the perfect fit for your
                project.
              </p>
            </li>
            <li>
              <h5>Global Reach for Your Business</h5>
              <p>Manzoul connects you with UK talented linguists, helping your business reach new heights and expand its
                international presence.
              </p>
            </li>
            <li>
              <h5>Secure and Transparent Transactions</h5>
              <p>Manzoul ensures secure transactions through a reliable escrow payment system. We hold the funds until
                clients are satisfied with the work, ensuring transparency and fair compensation.
              </p>
            </li>
            <li>
              <h5>Tailored Support</h5>
              <p>Choose your own linguists or let our team handle the entire project for you — we’re here to make it
                easy.
              </p>
          </ul>
        </div>

        <!-- For Linguists Column -->
        <div class="col-12 col-md-6 mb-4">
          <h4>For Linguists</h4>
          <ul class="mt-4">
            <li>
              <h5>Career Advancement</h5>
              <p>Create a free profile on Manzoul to advance your career, grow your business, and connect with clients
                globally. Let the work find you through our 24/7 marketing tool. Showcase your skills, and let work find
                you.</p>
            </li>
            <li>
              <h5>Navigate Challenges and Succeed</h5>
              <p>Manzoul stands by you in navigating the challenges of the language industry. We provide a platform
                where
                linguists can set their own rates, and prosper in their careers.
              </p>
            </li>
            <li>
              <h5>Global Visibility</h5>
              <p>Showcase your expertise on a global scale. Clients worldwide can view your profile, offering
                opportunities to collaborate on diverse projects.
              </p>
            </li>
            <li>
              <h5>Quick Payment Solution</h5>
              <p>Manzoul offers a secure and quick payment solution. Once a project is completed and approved by the
                client, we transfer the funds directly to your account.
              </p>
            </li>
            <li>
              <h5>Build Your Reputation</h5>
              <p>Earn reviews from satisfied clients to strengthen your professional profile.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="container desc-container">
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-12">
        <h3>Why Choose Manzoul?</h3>
        <ul class="mt-4">
          <li>
            <h5>Ethical Foundations</h5>
            <p>We prioritise values, not just transactions.
            </p>
          </li>
          <li>
            <h5>Free to Join</h5>
            <p>No registration or subscription fees.
            </p>
          </li>
          <li>
            <h5>Linguist-Led Design</h5>
            <p>Built with and for language professionals.
            </p>
          </li>
          <li>
            <h5>Supportive Environment</h5>
            <p>Our team is here to help with a responsive support system
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<section class="vid-container">
  <div class="container">
    <div class="row text-center">
      <div class="col-12 col-md-12 col-lg-12">
        <h3>From the Founder
        </h3>
        <p>
          Manzoul was founded by Fardous Bahbouh, an equality researcher specializing in translation and interpreting
          studies. Drawing on extensive expertise in the language industry and deep insights into the precarious
          conditions linguists often face, she created Manzoul to promote dignity, fairness, and transparency within the
          language insustry. Her vision is to combine efficiency, standards and ethics. The word Manzoul means, in
          Arabic, an “open community house.”
        </p>
        <p>Through a secure escrow payment system, verified reviews, and integrated messaging, Manzoul’s goal is to
          foster transparent, fair, and seamless collaboration—setting a higher standard for the industry.
        </p>
        <p>Be Part of the Change. Join Manzoul and help build a language services landscape that works for
          everyone—where professionalism is respected, earnings are fair, and ethical practice leads the way.</p>
      </div>
    </div>
  </div>
</section>

<app-footer></app-footer>